import { SocialSidebar } from "@/components/conduction-social/SocialSidebar";
import VideoGrid from "@/components/conduction-social/VideoGrid";
import { ProjectSubmission } from "@/javascript/project-objects";
import { allowedRoles, User } from "@/javascript/user-objects";
import { Box, Flex, Stack, useMantineTheme } from "@mantine/core";
import { useMemo, useState } from "react";

const projectOwner: User = {
	id: "user-01",
	username: "alice_smith",
	email: "alice@example.com",
	dateCreated: new Date("2023-01-01T12:00:00Z"),
	roles: [allowedRoles[0]],
	classroom: undefined,
	projectIds: ["project-001", "project-002"],
	completedBeginnerTutorial: true,
	artists: []
};

const videos: ProjectSubmission[] = [
	{
		id: "059efb19-d831-4350-80c8-160575820eb0",
		dateSubmitted: new Date("2025-07-09T09:00:00Z"),
		dateFulfilled: new Date("2025-07-09T09:00:00Z"),
		feedbackDateFulfilled: null,
		editorDueDate: new Date("2025-07-20T00:00:00Z"),
		instrumentalistDueDate: new Date("2025-07-15T00:00:00Z"),
		projectId: "project-001",
		videoEditor: null,
		feedbackProvider: null,
		projectOwner,
		submissionProjectName: "Cool Songggggggggssssssss",
		SongSubmissionUsage: [],
		instrumenatlistTasks: []
	},
	{
		id: "059efb19-d831-4350-80c8-160575820eb0",
		dateSubmitted: new Date("2025-07-09T09:00:00Z"),
		dateFulfilled: new Date("2025-07-09T09:00:00Z"),
		feedbackDateFulfilled: null,
		editorDueDate: new Date("2025-07-20T00:00:00Z"),
		instrumentalistDueDate: new Date("2025-07-15T00:00:00Z"),
		projectId: "project-001",
		videoEditor: null,
		feedbackProvider: null,
		projectOwner,
		submissionProjectName: "Cool Song",
		SongSubmissionUsage: [],
		instrumenatlistTasks: []
	},
	{
		id: "059efb19-d831-4350-80c8-160575820eb0",
		dateSubmitted: new Date("2025-07-09T09:00:00Z"),
		dateFulfilled: new Date("2025-07-09T09:00:00Z"),
		feedbackDateFulfilled: null,
		editorDueDate: new Date("2025-07-20T00:00:00Z"),
		instrumentalistDueDate: new Date("2025-07-15T00:00:00Z"),
		projectId: "project-001",
		videoEditor: null,
		feedbackProvider: null,
		projectOwner,
		submissionProjectName: "Funny Song",
		SongSubmissionUsage: [],
		instrumenatlistTasks: []
	},
	{
		id: "059efb19-d831-4350-80c8-160575820eb0",
		dateSubmitted: new Date("2025-07-09T09:00:00Z"),
		dateFulfilled: new Date("2025-07-09T09:00:00Z"),
		feedbackDateFulfilled: null,
		editorDueDate: new Date("2025-07-20T00:00:00Z"),
		instrumentalistDueDate: new Date("2025-07-15T00:00:00Z"),
		projectId: "project-001",
		videoEditor: null,
		feedbackProvider: null,
		projectOwner,
		submissionProjectName: "Happy Song",
		SongSubmissionUsage: [],
		instrumenatlistTasks: []
	},
	{
		id: "059efb19-d831-4350-80c8-160575820eb0",
		dateSubmitted: new Date("2025-07-09T09:00:00Z"),
		dateFulfilled: new Date("2025-07-09T09:00:00Z"),
		feedbackDateFulfilled: null,
		editorDueDate: new Date("2025-07-20T00:00:00Z"),
		instrumentalistDueDate: new Date("2025-07-15T00:00:00Z"),
		projectId: "project-001",
		videoEditor: null,
		feedbackProvider: null,
		projectOwner,
		submissionProjectName: "Sad Song",
		SongSubmissionUsage: [],
		instrumenatlistTasks: []
	},
	{
		id: "059efb19-d831-4350-80c8-160575820eb0",
		dateSubmitted: new Date("2025-07-09T09:00:00Z"),
		dateFulfilled: new Date("2025-07-09T09:00:00Z"),
		feedbackDateFulfilled: null,
		editorDueDate: new Date("2025-07-20T00:00:00Z"),
		instrumentalistDueDate: new Date("2025-07-15T00:00:00Z"),
		projectId: "project-001",
		videoEditor: null,
		feedbackProvider: null,
		projectOwner,
		submissionProjectName: "Fast Song",
		SongSubmissionUsage: [],
		instrumenatlistTasks: []
	},
	{
		id: "059efb19-d831-4350-80c8-160575820eb0",
		dateSubmitted: new Date("2025-07-09T09:00:00Z"),
		dateFulfilled: new Date("2025-07-09T09:00:00Z"),
		feedbackDateFulfilled: null,
		editorDueDate: new Date("2025-07-20T00:00:00Z"),
		instrumentalistDueDate: new Date("2025-07-15T00:00:00Z"),
		projectId: "project-001",
		videoEditor: null,
		feedbackProvider: null,
		projectOwner,
		submissionProjectName: "Cool Song",
		SongSubmissionUsage: [],
		instrumenatlistTasks: []
	},
	{
		id: "059efb19-d831-4350-80c8-160575820eb0",
		dateSubmitted: new Date("2025-07-09T09:00:00Z"),
		dateFulfilled: new Date("2025-07-09T09:00:00Z"),
		feedbackDateFulfilled: null,
		editorDueDate: new Date("2025-07-20T00:00:00Z"),
		instrumentalistDueDate: new Date("2025-07-15T00:00:00Z"),
		projectId: "project-001",
		videoEditor: null,
		feedbackProvider: null,
		projectOwner,
		submissionProjectName: "Cool Song",
		SongSubmissionUsage: [],
		instrumenatlistTasks: []
	},
	{
		id: "059efb19-d831-4350-80c8-160575820eb0",
		dateSubmitted: new Date("2025-07-09T09:00:00Z"),
		dateFulfilled: new Date("2025-07-09T09:00:00Z"),
		feedbackDateFulfilled: null,
		editorDueDate: new Date("2025-07-20T00:00:00Z"),
		instrumentalistDueDate: new Date("2025-07-15T00:00:00Z"),
		projectId: "project-001",
		videoEditor: null,
		feedbackProvider: null,
		projectOwner,
		submissionProjectName: "Funny Song",
		SongSubmissionUsage: [],
		instrumenatlistTasks: []
	},
	{
		id: "059efb19-d831-4350-80c8-160575820eb0",
		dateSubmitted: new Date("2025-07-09T09:00:00Z"),
		dateFulfilled: new Date("2025-07-09T09:00:00Z"),
		feedbackDateFulfilled: null,
		editorDueDate: new Date("2025-07-20T00:00:00Z"),
		instrumentalistDueDate: new Date("2025-07-15T00:00:00Z"),
		projectId: "project-001",
		videoEditor: null,
		feedbackProvider: null,
		projectOwner,
		submissionProjectName: "Happy Song",
		SongSubmissionUsage: [],
		instrumenatlistTasks: []
	},
	{
		id: "059efb19-d831-4350-80c8-160575820eb0",
		dateSubmitted: new Date("2025-07-09T09:00:00Z"),
		dateFulfilled: new Date("2025-07-09T09:00:00Z"),
		feedbackDateFulfilled: null,
		editorDueDate: new Date("2025-07-20T00:00:00Z"),
		instrumentalistDueDate: new Date("2025-07-15T00:00:00Z"),
		projectId: "project-001",
		videoEditor: null,
		feedbackProvider: null,
		projectOwner,
		submissionProjectName: "Sad Song",
		SongSubmissionUsage: [],
		instrumenatlistTasks: []
	},
	{
		id: "059efb19-d831-4350-80c8-160575820eb0",
		dateSubmitted: new Date("2025-07-09T09:00:00Z"),
		dateFulfilled: new Date("2025-07-09T09:00:00Z"),
		feedbackDateFulfilled: null,
		editorDueDate: new Date("2025-07-20T00:00:00Z"),
		instrumentalistDueDate: new Date("2025-07-15T00:00:00Z"),
		projectId: "project-001",
		videoEditor: null,
		feedbackProvider: null,
		projectOwner,
		submissionProjectName: "Fast Song",
		SongSubmissionUsage: [],
		instrumenatlistTasks: []
	}
];



const Social: React.FC = () => {
	const theme = useMantineTheme();
	const [search, _] = useState<string>("");
  
	const filteredVideos = useMemo(() => {
	  if (!videos) return [];
	  if (!search) return videos;
	  const query = search.toLowerCase();
	  return videos.filter(
		(video) =>
		  video.submissionProjectName?.toLowerCase().includes(query) ||
		  video.projectOwner?.username.toLowerCase().includes(query)
	  );
	}, [videos, search]);
  
	return (
	  <Flex w="100vw" h="100vh" style={{ overflow: "hidden" }}>
		{/* Sidebar fixed width */}
		<Box
		  style={{
			position: "fixed",
			width: 300,
			zIndex: "100",
			height: "100%",
			flexShrink: 0,
			backgroundColor: theme.colors.blue[6], // adjust color if needed
			overflowY: "auto"
		  }}
		>
		  <SocialSidebar />
		</Box>
  
		{/* Main content scrollable */}
		<Box
		  ml={"300px"}
		  style={{
			flex: 1,
			height: "100%",
			overflowY: "auto",
		  }}
		>
		  <Stack align={"center"} justify={"center"}>
			{/* <GridHeader>
			  <Text
				p={20}
				ml={isMobile ? 10 : 20}
				fz={isMobile ? 15 : 45}
				c={theme.colors.blue[0]}
				ta="center"
				style={{ minWidth: 0 }}
			  >
				Social
			  </Text>
			  <Box style={{ flex: 1, display: "flex", justifyContent: "center" }}>
				<TextInput
				  radius="xl"
				  size={isMobile ? "xs" : "md"}
				  placeholder="Search library..."
				  onChange={(e) => setSearch(e.currentTarget.value)}
				  rightSectionWidth={42}
				  leftSection={<IconSearch size={18} stroke={1.5} color={"#5A80A0"} />}
				  rightSection={
					<ActionIcon size={isMobile ? 20 : 32} radius="xl" color={"#5A80A0"} variant="filled">
					  <IconArrowRight size={isMobile ? 10 : 18} stroke={1.5} color={"#E8F1F9"} />
					</ActionIcon>
				  }
				  style={{ maxWidth: rem(260), width: "100%" }}
				/>
			  </Box>
			</GridHeader>  */}
  
			<Box w="100%" mt={20}>
			  <VideoGrid videos={filteredVideos} skeletonSize={3} />
			</Box>
		  </Stack>
		</Box>
	  </Flex>
	);
  };
  
  export default Social;